import React from 'react';
import { getFinalStyle } from '../sharedBetweenInfoComponents';
export default class Title extends React.Component {
  render() {
    const title = this.props.title;
    const finalStyle = getFinalStyle(this.props);
    if (this.props.isNewInfoElements) {
      finalStyle.marginBottom = finalStyle.paddingBottom;
      delete finalStyle.paddingBottom;
    }
    // TODO: Line height fixer changes the styles of the span directly on the DOM node. Since I don't have a awy to reset it everytime the fixer runs, I actually remove the entire DOM node. This should be handled in a better way
    const RANDOM_KEY_THAT_CAUSES_PERFORMANCE_PROBLEM = this.props.isNewInfoElements ? Math.random() : 'CONST';
    return /*#__PURE__*/React.createElement("div", {
      key: RANDOM_KEY_THAT_CAUSES_PERFORMANCE_PROBLEM,
      className: "info-member info-element-title",
      "data-hook": "item-title",
      style: finalStyle
    }, /*#__PURE__*/React.createElement("span", null, title));
  }
}
//# sourceMappingURL=Title.js.map